var nextPage = 2;

document.getElementById('load-new-posts').addEventListener('click', function(e) {
    e.preventDefault();
    const container = document.getElementById('postContainer');
    const button = this;
    let pathArray = window.location.pathname.split('/');
    let xhr = new XMLHttpRequest();
    let url = new URL(window.location.origin+"/fetch-news");
    url.searchParams.append('page', nextPage);
    if(pathArray.length > 3 ) {
        url.searchParams.append('searchBy', pathArray[2]);
        url.searchParams.append('searchValue', pathArray[3]);
    }
    xhr.open("GET", url);
    xhr.send();

    xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            // ++currentPostPage;
            let response = JSON.parse(xhr.response);

            if(response.nextPage == -1) {
                button.remove();
            } else {
                
                nextPage = response.nextPage;
            }
            container.innerHTML += response.postsHtml;
            // console.log(response);
        }
    };
})